export default {
    apiKey: "AIzaSyD8nDVl-lf12xBErX1Il9-Mp5RBPxnTxuw",
    authDomain: "vue-fs-f7b5d.firebaseapp.com",
    databaseURL: "https://vue-fs-f7b5d.firebaseio.com",
    projectId: "vue-fs-f7b5d",
    storageBucket: "vue-fs-f7b5d.appspot.com",
    messagingSenderId: "1040249582488"
}